export const SECTION_STATUSES = ['draft', 'active', 'inactive'] as const

export type SectionStatus = (typeof SECTION_STATUSES)[number]
